import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { IUploadService } from '../helpers';
import { IUploadResult, IUploadResultApi } from '../../models';

export interface ILicenseService {
    upload(file: File): angular.IPromise<IUploadResult>;
    generate(): angular.IPromise<any>;
}

export class LicenseService implements ILicenseService {
    static serviceId = 'licenseService';

    static $inject = [
        'requestService',
        'uploadService'
    ];

    private _controllerUrl = 'license';

    constructor(
        private _requestService: IRequestService,
        private _uploadService: IUploadService
    ) {
    }

    upload(file: File): angular.IPromise<IUploadResult> {
        const url = `${this._requestService.getUrlV1()}${this._controllerUrl}/upload`;
        return this._uploadService
            .uploadFile<IUploadResultApi>(url, file)
            .then(data => {
                this._requestService.cleanCacheAtV1('ApiInformation');
                return { result: data.item1, message: data.item2 };
            });
    }

    generate(): angular.IPromise<any> {
        return this._requestService
            .getAtV1(this._controllerUrl)
            .then(data => {
                this._uploadService.download(data, 'license.json', 'application/json');
            });
    }
}